import React, { useState, useEffect } from 'react';
import { Route, Routes, useLocation, Navigate, Outlet } from 'react-router-dom';
import { AuthProvider, useAuth } from './components/context/AuthContext';

// Start Auth Pages
import Login from './components/auth/Login';

// Start Main Sections
import Footer from './components/main/Footer';

// Start Site Pages
import NotFound from './components/pages/NotFound';

// Start Admin Pages
import UserProfile from './components/admin/UserProfile';
import Dashboard from './components/admin/Dashboard';
import Blog from './components/admin/Blog';
import Consultations from './components/admin/Consultations';
import ContactInformation from './components/admin/ContactInformation';
import Countries from './components/admin/Countries';
import CustomerReviews from './components/admin/CustomerReviews';
import Inbox from './components/admin/Inbox';
import Locations from './components/admin/Locations';
import Partners from './components/admin/Partners';
import ProjectConsulting from './components/admin/ProjectConsulting';
import Projects from './components/admin/Projects';
import Statistics from './components/admin/Statistics';
import Subscriptions from './components/admin/Subscriptions';
import CreateUser from './components/admin/CreateUser';


// Start Hooks Pages
import Loader from './components/section/Loader';
import Top from './components/Top';
import ScrollToTop from './components/ScrollToTop';
import UseScrollAnimation from './Hooks/UseScrollAnimation';

const RedirectHome = () => {
  return <Navigate to={'/login'} replace />;
};

const ProtectedRoute = () => {
  const { token } = useAuth();
  if (!token) {
    return <Navigate to="/login" replace />;
  }
  return <Outlet />;
};

const App = () => {
  const location = useLocation();
  const [isNotFound,] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    setIsLoading(true);
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 1500);

    return () => clearTimeout(timer);
  }, [location.pathname]);

  const authRoutes = ['/login'];
  const isAuthRoute = authRoutes.some(route => location.pathname.includes(route));

  return (
    <AuthProvider>
      {isLoading && <Loader />}
      {!isAuthRoute && !isNotFound && <Top />}
      <Routes>
        <Route path='/login' element={<Login />} />
        <Route path='/secret/page/create-user' element={<CreateUser />} />
        <Route path='/' element={<RedirectHome />} />
        <Route element={<ProtectedRoute />}>
          <Route path='profile/' element={<UserProfile />}>
            <Route path='dashboard' element={<Dashboard />} />
            <Route path='countries' element={<Countries />} />
            <Route path='projects' element={<Projects />} />
            <Route path='statistics' element={<Statistics />} />
            <Route path='project-consulting' element={<ProjectConsulting />} />
            <Route path='partners' element={<Partners />} />
            <Route path='locations' element={<Locations />} />
            <Route path='inbox' element={<Inbox />} />
            <Route path='customer-reviews' element={<CustomerReviews />} />
            <Route path='blog' element={<Blog />} />
            <Route path='consultations' element={<Consultations />} />
            <Route path='contact-information' element={<ContactInformation />} />
            <Route path='subscriptions' element={<Subscriptions />} />
          </Route>
        </Route>
        <Route path='*' element={<NotFound />} />
      </Routes>
      {!isAuthRoute && !isNotFound && <Footer />}
      <ScrollToTop />
      <UseScrollAnimation />
    </AuthProvider>
  );
};

export default App;